export const config = {
    // Server: "http://localhost:5129",
    // Client: "http://localhost:3000",
    Server:"https://Classico7.ir",
    Client:"https://Classico7.ir",
    FileExplorerPageSize: 20,
    GeneralListPageSize: 50,
    ShowListId: false,
};